import React from 'react';
import { BookOpen, ChevronDown, ChevronRight, FileText } from 'lucide-react';

const NumoraSidebarSection = ({
  user,
  isOpen,
  setIsOpen,
  activeMenuItem,
  handleSelectTool,
  closeOtherSections,
}) => {
  const canAccess = user?.permissions?.numora_access === true;
  if (!canAccess) return null;

  return (
    <div className="mt-2">
      <button
        onClick={() => {
          const next = !isOpen;
          setIsOpen(next);
          if (next && typeof closeOtherSections === 'function') {
            closeOtherSections();
          }
        }}
        className="w-full flex items-center justify-between gap-3 px-3 py-2 rounded-lg text-left transition-colors text-gray-700 dark:text-gray-100 hover:bg-indigo-50 dark:hover:bg-black"
      >
        <div className="flex items-center gap-3">
          <BookOpen className="h-4 w-4" />
          Numora
        </div>
        {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
      </button>

      {isOpen && (
        <div className="ml-6 mt-2 space-y-1">
          <button
            onClick={() => handleSelectTool('numora-sales-book')}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
              activeMenuItem === 'numora-sales-book'
                ? 'bg-indigo-50 text-indigo-600 border-l-2 border-indigo-400'
                : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
            }`}
          >
            <FileText className="h-3 w-3" />
            Sales Book
          </button>
          <button
            onClick={() => handleSelectTool('numora-cash-receipt-book')}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
              activeMenuItem === 'numora-cash-receipt-book'
                ? 'bg-indigo-50 text-indigo-600 border-l-2 border-indigo-400'
                : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
            }`}
          >
            <FileText className="h-3 w-3" />
            Cash Receipt Book
          </button>
          <button
            onClick={() => handleSelectTool('numora-accounts-payable-journal')}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
              activeMenuItem === 'numora-accounts-payable-journal'
                ? 'bg-indigo-50 text-indigo-600 border-l-2 border-indigo-400'
                : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
            }`}
          >
            <FileText className="h-3 w-3" />
            Accounts Payable Journal
          </button>
          <button
            onClick={() => handleSelectTool('numora-cash-disbursement-book')}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
              activeMenuItem === 'numora-cash-disbursement-book'
                ? 'bg-indigo-50 text-indigo-600 border-l-2 border-indigo-400'
                : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
            }`}
          >
            <FileText className="h-3 w-3" />
            Cash Disbursement Book
          </button>
          <button
            onClick={() => handleSelectTool('numora-journal-book')}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
              activeMenuItem === 'numora-journal-book'
                ? 'bg-indigo-50 text-indigo-600 border-l-2 border-indigo-400'
                : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
            }`}
          >
            <FileText className="h-3 w-3" />
            Journal Book
          </button>
        </div>
      )}
    </div>
  );
};

export default NumoraSidebarSection;
